import _ from 'lodash';
import React, { Component } from 'react';

import { StarRating } from '../shared';

import {
  getFourboxTalentCategories,
  getDefaultTalentRatingExplanations,
  getDefaultTalentRatingExplanationForValue,
} from '../../util';
import {
  getIcon
} from '../../util/icons';

class CompleteTalentCard extends Component {

  state = {
    talents: [],
    ratings: {},
  }

  ratingForTalentId(talentId){
    return this.state.ratings[talentId] || 0;
  }
  priorRatingForTalentId(talentId){

    const { priorReviews } = this.props;

    if(priorReviews){

      let matchingPriorReviews = {};

      if(this.props.isOwnCard){
        matchingPriorReviews = priorReviews.selfReview || priorReviews.jointReview;
      }
      else{
        matchingPriorReviews = priorReviews.managerReview || priorReviews.jointReview;
      }

      if(!matchingPriorReviews){
        return 0;
      }

      // console.log('calculating rating w/ rating data: ', matchingPriorReviews.ratings);

      return matchingPriorReviews.ratings[talentId];
    }
    else{
      return 0;
    }
  }

  getInitialRatingsForTalents(talents){
    let initialRatings = {};

     _.each(talents, talent => {
      initialRatings[talent.id] = this.priorRatingForTalentId(talent.id);
    });

    return initialRatings;
  }

  componentWillMount(){
    console.log('complete talent eval mounted!');

    const talents = this.props.talents;

    //console.log('setting prior reviews to: ', this.props.priorReviews);

    this.setState({
      talents,
      ratings: this.getInitialRatingsForTalents(talents)
    });
  }

  formIsComplete(){
    let allTalentsHaveRatings = true;

    const { talents, ratings } = this.state;

    _.each(talents, talent => {
      if(ratings[talent.id] === undefined){
        allTalentsHaveRatings = false;
      }
      else if(ratings[talent.id] === 0){
        allTalentsHaveRatings = false;
      }
    });

    // console.log(talents);
    // console.log(ratings);
    // console.log('allTalentsHaveRatings: ', allTalentsHaveRatings);

    return allTalentsHaveRatings;
  }

  submitRatings(){
    if(!this.formIsComplete()){
      return;
    }

    this.props.submitRatings(this.state.ratings);
  }

  renderActions(){

    const formIsComplete = this.formIsComplete();

    console.log('formIsComplete: ', formIsComplete);

    return(
      <div className="actions">
        <button onClick={this.submitRatings.bind(this)} className="button primary" disabled={!formIsComplete || this.props.submittingRatings}>Submit ratings</button>
        {this.isFocusingTalents() && !this.state.showingAllTalents &&
          <button onClick={() => { this.setState({ showingAllTalents: true }) }} className="button grey-button">Update other talents (optional)</button>
        }
        <button onClick={this.props.cancel} className="button grey-outline button-sm cancel">Cancel and discard responses</button>
      </div>
    )
  }

  focusedTalentsForCategory(category){
    //use this state talents
    return _.filter(this.state.talents, talent => {

      if(talent.category !== category){
        return false;
      }

      if(this.props.onlyShowFocused && this.props.focusedTalents && this.props.focusedTalents.length > 0){
        //else...only show evaluating talents
        const isEvaluatingThisTalent = _.find(this.props.focusedTalents, evaluatingTalent => {
          return evaluatingTalent.id === talent.id;
        });

        return isEvaluatingThisTalent ? true : false;
      }
      else{
        return true;
      }
    });
  }
  nonFocusedTalents(){
    return _.xorBy(this.state.talents, this.props.focusedTalents, 'id');
  }

  isFocusingTalents(){
    return this.props.onlyShowFocused;
  }

  updateTalentRating(talent, newRating){
    this.setState({
      ratings: {
        ...this.state.ratings,
        [talent.id]: newRating
      }
    }, () => {
      console.log('updating rating state: ', this.state);
    });
  }

  renderTalentRatings(talent){
    if(this.props.priorReviews){

      console.log('this.props.priorReviews: ', this.props.priorReviews);

      const priorRating = this.priorRatingForTalentId(talent.id);

      return(
        <div className="talent-ratings multiple">
          <div className="talent-rating">
            <StarRating
              ratingLabel="New talent rating"
              maxRating={7}
              currentRating={this.ratingForTalentId(talent.id)}
              updateRating={rating => { this.updateTalentRating(talent, rating); }}
              ratingExplanations={talent.ratings || getDefaultTalentRatingExplanations()}
              includeRatingExplanationPlaceholder={true}
            />
          </div>
          <div className="talent-rating">
            <StarRating
              ratingLabel={this.props.priorReviews.period === 'Initial' ? 'Initial evaluation rating' : 'Prior rating'}
              className="prior"
              maxRating={7}
              currentRating={priorRating}
              ratingExplanation={talent.ratings ? talent.ratings[priorRating - 1] : getDefaultTalentRatingExplanationForValue(priorRating)}
            />
          </div>
        </div>
      )
    }
    else{
      return (
        <div className="talent-ratings">
          <div className="talent-rating">
            <StarRating
              ratingLabel=""
              maxRating={7}
              currentRating={this.ratingForTalentId(talent.id)}
              updateRating={rating => { this.updateTalentRating(talent, rating); }}
              ratingExplanations={talent.ratings || getDefaultTalentRatingExplanations()}
              includeRatingExplanationPlaceholder={true}
            />
          </div>
        </div>
      )
    }
  }

  talentIsFocused(talent){
    return _.find(this.props.focusedTalents, matchingTalent => {
      return matchingTalent.id === talent.id;
    }) ? true : false;
  }

  renderTalent(talent){

    const talentIsFocused = this.talentIsFocused(talent);

    return(
      <div key={talent.id} className="talent">
        <div className="talent-info">
          {talentIsFocused &&
            <div className="focus-icon" data-tip="Current sprint goal">{getIcon('sprint')}</div>
          }
          <div className="talent-name">{talent.name}</div>
          <div className="talent-definition fs-block">{talent.definition || `Example definition for ${talent.name}`}</div>
        </div>
        {this.renderTalentRatings(talent)}
      </div>
    )
  }

  render(){
    return(
      <div className="talent-evaluation-review">
        <div className="organization-talents">
          {this.isFocusingTalents() &&
            <h3>Talents focused on this quarter:</h3>
          }
          {_.map(getFourboxTalentCategories(), talentCategory => {
            return (
              <div key={talentCategory.key} className="talent-category">
                <div className="talents-section-header">{talentCategory.name}</div>
                {_.map(this.focusedTalentsForCategory(talentCategory.key), this.renderTalent.bind(this))}
              </div>
            );
          })}
          {this.state.showingAllTalents &&
            <div className="talent-category">
              <div className="talents-section-header">Non-focused talents</div>
              {_.map(this.nonFocusedTalents(), this.renderTalent.bind(this))}
            </div>
          }
          {this.renderActions()}
        </div>
      </div>
    );
  }
}

export default CompleteTalentCard;



// WEBPACK FOOTER //
// ./src/components/talents/completeTalentEvaluation.js